export const isHttpsUrl = (v) => /^https:\/\/[^\s/$.?#][^\s]*\.[^\s]+$/i.test((v || "").trim());
